import type { Snippet } from 'svelte';
import type { LinkData } from '@athena-lib/Link';
import type { ClickEvent } from '@athena-lib/types';

export type DrawerProps = {
  children: Snippet;
  isOpen: boolean;
  variant: 'hamburger-menu' | 'minicart';
  onClose: () => void;
  navigate?: (url: string) => void;
  label: string;
  disablePadding?: boolean;
};

export type DrawerMenuItem = {
  link: LinkData;
  text: string;
};

export type DrawerMenuProps = {
  mainMenuItems: DrawerMenuItem[];
  secondaryMenuItems: DrawerMenuItem[];
  tertiaryMenuItems: DrawerMenuItem[];
  closeDrawer: () => void;
  signInLinkText: string;
  accountLinkText: string;
  reorderLinkText: string;
  reorderUrl: string;
  restoreFocus: () => void;
  onAccountClick: (e: ClickEvent<HTMLElement>) => void;
};

export const drawerContextKey = Symbol('athena-drawer');

export type DrawerContext = {
  close: () => void;
  navigate: (url: string) => void;
};
